<template>
  <div class="order-submission">
    <div
      class="allAddress"
      :style="store_self_mention ? '' : 'padding-top: 0.2rem'"
      v-if="
        orderGroupInfo.cartInfo &&
          orderGroupInfo.cartInfo[0].productInfo.istype !== 7
      "
    >
      <!-- <div
        class="nav acea-row"
        v-if="istype !== 5 && istype !== 9 && istype !== 11"
      >
        <div
          class="item font-color-red"
          :class="shipping_type === 0 ? 'on' : 'on2'"
          @click="addressType(0)"
          v-if="store_self_mention"
        ></div>
        <div
          class="item font-color-red"
          :class="shipping_type === 1 ? 'on' : 'on2'"
          @click="addressType(1)"
          v-if="store_self_mention"
        ></div>
      </div> -->
      <div
        class="nav acea-row"
        v-if="istype !== 5 && istype !== 9 && istype !== 11"
      >
        <div
          class="item font-color-red"
          :class="shipping_type === 0 ? 'on' : 'on2'"
          @click="addressType(0)"
          v-if="store_self_mention"
        ></div>
        <div
          class="item font-color-red"
          :class="shipping_type === 1 ? 'on' : 'on3'"
          v-if="store_self_mention"
        ></div>
      </div>

      <div
        class="nav acea-row"
        v-if="(istype_hx && istype == 5) || istype == 9 || istype == 11"
      >
        <div
          class="item font-color-red"
          :class="shipping_type === 0 ? 'on' : 'on3'"
          v-if="store_self_mention"
        ></div>
        <div
          class="item font-color-red"
          :class="shipping_type === 1 ? 'on' : 'on2'"
          @click="addressType(1)"
          v-if="store_self_mention"
        ></div>
      </div>

      <div class="nav acea-row" v-if="istype == 5 && !istype_hx">
        <div
          class="item font-color-red"
          :class="shipping_type === 0 ? 'on' : 'on2'"
          @click="addressType(0)"
          v-if="store_self_mention"
        ></div>
        <div
          class="item font-color-red"
          :class="shipping_type === 1 ? 'on' : 'on3'"
          v-if="store_self_mention"
        ></div>
      </div>

      <div
        class="address acea-row row-between-wrapper"
        v-if="shipping_type === 0"
        @click="addressTap"
      >
        <div class="addressCon" v-if="addressInfo.real_name">
          <div class="name">
            {{ addressInfo.real_name }}
            <span class="phone">{{ addressInfo.phone }}</span>
          </div>
          <div>
            <span class="default font-color-red" v-if="addressInfo.is_default"
              >[默认]</span
            >
            {{ addressInfo.province }}{{ addressInfo.city
            }}{{ addressInfo.district }}{{ addressInfo.detail }}
          </div>
        </div>
        <div class="addressCon" v-else>
          <div class="setaddress">设置收货地址</div>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <div
        class="address acea-row row-between-wrapper"
        v-if="
          shipping_type === 1 && istype !== 11 && istype !== 5 && is_hx != 1
        "
        @click="showStoreList"
      >
        <div class="addressCon">
          <div class="name" v-if="storeItem">
            {{ storeItem.name }}
            <span class="phone" v-text="storeItem.phone"></span>
          </div>
          <div
            v-text="storeItem.address + ',' + storeItem.detailed_address"
            v-if="storeItem && storeItem.address && storeItem.detailed_address"
          ></div>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <div class="line" v-if="istype !== 11 && istype !== 5 && is_hx != 1">
        <img src="@assets/images/line.jpg" />
      </div>
    </div>
    <OrderGoods :evaluate="0" :cartInfo="orderGroupInfo.cartInfo"></OrderGoods>
    <div class="wrapper">
      <div
        class="item acea-row row-between-wrapper"
        @click="couponTap"
        v-if="deduction === false && false"
      >
        <div>优惠券</div>
        <div class="discount">
          {{ usableCoupon.coupon_title || "请选择" }}
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="
          deduction === false &&
            orderGroupInfo.cartInfo &&
            orderGroupInfo.cartInfo[0].productInfo.istype == 0
        "
      >
        <div>电子积分抵扣</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="useIntegral" />
                <i class="icon"></i>
                <span class="integral">
                  当前电子积分
                  <span class="num font-color-red">
                    {{ userInfo.integral || 0 }}
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderGroupInfo.is_mjf_ms == 1"
      >
        <div>邈积分模式</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="mjf_ms" />
                <i class="icon"></i>
                <span class="integral">
                  是否使用
                  <span class="num font-color-red">
                    <!-- {{ userInfo.integral_fg || 0 }} -->
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="mjf_ms">
        <div>需要邈积分</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              {{ orderPrice.mjf_num || 0 }}
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="item acea-row row-between-wrapper" v-if="deduction === false">
        <div>复购积分抵扣</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="useIntegralFg" />
                <i class="icon"></i>
                <span class="integral">
                  当前复购积分
                  <span class="num font-color-red">
                    {{ userInfo.integral_fg || 0 }}
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div> -->
      <div
        class="item acea-row row-between-wrapper"
        v-if="
          orderGroupInfo.priceGroup.vipPrice > 0 &&
            userInfo.vip &&
            pinkId == 0 &&
            orderGroupInfo.bargain_id == 0 &&
            orderGroupInfo.combination_id == 0 &&
            orderGroupInfo.seckill_id == 0
        "
      >
        会员优惠
        <div class="discount">-￥{{ orderGroupInfo.priceGroup.vipPrice }}</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="shipping_type === 0">
        <div>快递费用</div>
        <div class="discount">
          {{
            orderPrice.pay_postage > 0
              ? "￥" + orderPrice.pay_postage
              : "免运费"
          }}
        </div>
      </div>
      <div v-if="shipping_type === 1 && istype != 11">
        <div class="item acea-row row-between-wrapper">
          <div>联系人</div>
          <div class="discount">
            <input
              type="text"
              placeholder="请填写您的联系姓名"
              v-model="contacts"
            />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>联系电话</div>
          <div class="discount">
            <input
              type="text"
              placeholder="请填写您的联系电话"
              v-model="contactsTel"
            />
          </div>
        </div>
      </div>
      <div class="item">
        <div>备注信息</div>
        <textarea
          placeholder="请添加备注（150字以内）"
          v-model="mark"
        ></textarea>
      </div>
    </div>
    <div class="wrapper">
      <div class="item">
        <div>支付方式</div>
        <div class="list">
          <div
            class="payItem acea-row row-middle"
            :class="active === 'weixin' ? 'on' : ''"
            @click="payItem('weixin')"
            v-show="isWeixin"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-weixin2"
                :class="active === 'weixin' ? 'bounceIn' : ''"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'alipay' ? 'on' : ''"
            @click="payItem('alipay')"
            v-show="!isWeixin"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-zhifubao"
                :class="active === 'alipay' ? 'bounceIn' : ''"
              ></div>
              支付宝支付
            </div>
            <div class="tip">支付宝快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'weixin' ? 'on' : ''"
            @click="payItem('weixin')"
            v-show="!isWeixin"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-weixin2"
                :class="active === 'weixin' ? 'bounceIn' : ''"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'lsjf' ? 'on' : ''"
            @click="payItem('lsjf')"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-icon-test"
                :class="active === 'lsjf' ? 'bounceIn' : ''"
              ></div>
              创富积分支付
            </div>
            <div class="tip">可用创富积分：{{ userInfo.lsjf || 0 }}</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'offline' ? 'on' : ''"
            @click="payItem('offline')"
            v-if="
              offlinePayStatus === 1 &&
                deduction === false &&
                shipping_type === 0
            "
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-yinhangqia"
                :class="active === 'offline' ? 'bounceIn' : ''"
              ></div>
              线下支付
            </div>
            <div class="tip">线下方便支付</div>
          </div>
        </div>
      </div>
    </div>
    <div class="moneyList">
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.total_price !== undefined"
      >
        <div>商品总价：</div>
        <div class="money">￥{{ orderPrice.total_price }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.pay_postage > 0"
      >
        <div>运费：</div>
        <div class="money">+￥{{ orderPrice.pay_postage }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.coupon_price > 0"
      >
        <div>优惠券抵扣：</div>
        <div class="money">-￥{{ orderPrice.coupon_price }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.deduction_price > 0"
      >
        <div>电子积分抵扣：</div>
        <div class="money">-￥{{ orderPrice.deduction_price }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.deduction_price_fg > 0"
      >
        <div>复购积分抵扣：</div>
        <div class="money">-￥{{ orderPrice.deduction_price_fg }}</div>
      </div>
    </div>

    <div style="height:1.2rem"></div>
    <div class="footer acea-row row-between-wrapper">
      <div>
        合计:
        <span class="icon-color">￥{{ orderPrice.pay_price }}</span>
        <span class="icon-color" v-if="istype == 8">
          + {{ orderPrice.integral_qd }}签到积分</span
        >
      </div>
      <div class="settlement" @click="createOrder">立即结算</div>
    </div>
    <CouponListWindow
      v-on:couponchange="changecoupon($event)"
      v-model="showCoupon"
      :price="orderPrice.total_price"
      :checked="usableCoupon.id"
      :cartid="cartid"
      @checked="changeCoupon"
    ></CouponListWindow>
    <AddressWindow
      @checked="changeAddress"
      @redirect="addressRedirect"
      v-model="showAddress"
      :checked="addressInfo.id"
      ref="mychild"
    ></AddressWindow>
  </div>
</template>
<style scoped>
.order-submission .wrapper .shipping select {
  color: #999;
  padding-right: 0.15rem;
}

.order-submission .wrapper .shipping .iconfont {
  font-size: 0.3rem;
  color: #515151;
}

.order-submission .allAddress {
  width: 100%;
  background-image: linear-gradient(to bottom, #0e98fd 0%, #f5f5f5 100%);
  background-image: -webkit-linear-gradient(
    to bottom,
    #0e98fd 0%,
    #f5f5f5 100%
  );
  background-image: -moz-linear-gradient(to bottom, #0e98fd 0%, #f5f5f5 100%);
  padding-top: 1rem;
}

.order-submission .allAddress .nav {
  width: 7.1rem;
  margin: 0 auto;
}

.order-submission .allAddress .nav .item {
  width: 3.55rem;
}

.order-submission .allAddress .nav .item.on {
  position: relative;
  width: 2.5rem;
}

.order-submission .allAddress .nav .item.on:before {
  position: absolute;
  bottom: 0;
  content: "快递配送";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 3.55rem;
  border-width: 0 0.2rem 0.8rem 0;
  border-style: none solid solid;
  border-color: transparent transparent #fff;
  z-index: 9;
  border-radius: 0.07rem 0.3rem 0 0;
  text-align: center;
  line-height: 0.8rem;
}

.order-submission .allAddress .nav .item:nth-of-type(2).on:before {
  content: "到店自提";
  border-width: 0 0 0.8rem 0.2rem;
  border-radius: 0.3rem 0.07rem 0 0;
}

.order-submission .allAddress .nav .item.on2 {
  position: relative;
}

.order-submission .allAddress .nav .item.on2:before {
  position: absolute;
  bottom: 0;
  content: "到店自提";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 4.6rem;
  border-width: 0 0 0.6rem 0.6rem;
  border-style: none solid solid;
  border-color: transparent transparent #f7c1bd;
  border-radius: 0.4rem 0.06rem 0 0;
  text-align: center;
  line-height: 0.6rem;
}

.order-submission .allAddress .nav .item:nth-of-type(1).on2:before {
  content: "快递配送";
  border-width: 0 0.6rem 0.6rem 0;
  border-radius: 0.06rem 0.4rem 0 0;
}

.order-submission .allAddress .nav .item.on3 {
  position: relative;
}

.order-submission .allAddress .nav .item.on3:before {
  position: absolute;
  bottom: 0;
  content: "";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 4.6rem;
  border-width: 0 0 0.6rem 0.6rem;
  border-style: none solid solid;
  border-color: transparent transparent #f7c1bd;
  border-radius: 0.4rem 0.06rem 0 0;
  text-align: center;
  line-height: 0.6rem;
}

.order-submission .allAddress .nav .item:nth-of-type(1).on3:before {
  content: "";
  border-width: 0 0.6rem 0.6rem 0;
  border-radius: 0.06rem 0.4rem 0 0;
}

.order-submission .allAddress .address {
  width: 7.1rem;
  height: 1.5rem;
  margin: 0 auto;
}

.order-submission .allAddress .line {
  width: 7.1rem;
  margin: 0 auto;
}

.order-submission .wrapper .item .discount input::placeholder {
  color: #ccc;
}
</style>
<script>
import OrderGoods from "@components/OrderGoods";
import CouponListWindow from "@components/CouponListWindow";
import AddressWindow from "@components/AddressWindow";
import { postOrderConfirm, postOrderComputed, createOrder } from "@api/order";
import { storeListApi } from "@api/store";
import { getUser } from "@api/user";
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";
import { mapGetters } from "vuex";
import cookie from "@utils/store/localStorage";
const NAME = "OrderSubmission",
  _isWeixin = isWeixin();
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
export default {
  name: NAME,
  components: {
    OrderGoods,
    CouponListWindow,
    AddressWindow
  },
  props: {},
  computed: {
    ...mapGetters(["storeItems"]),
    storeItem: function() {
      if (JSON.stringify(this.storeItems) == "{}") {
        return this.storeList;
      } else {
        return this.storeItems;
      }
    }
  },
  data: function() {
    return {
      is_hx: 0,
      cartid: "",
      offlinePayStatus: 2,
      from: _isWeixin ? "weixin" : "weixinh5",
      deduction: true,
      isWeixin: _isWeixin,
      pinkId: 0,
      active: "lsjf",
      showCoupon: false,
      showAddress: false,
      addressInfo: {},
      couponId: 0,
      orderGroupInfo: {
        priceGroup: {}
      },
      usableCoupon: {},
      addressLoaded: false,
      useIntegral: true,
      useIntegralFg: false,
      mjf_ms: false,
      orderPrice: {
        pay_price: "计算中"
      },
      mark: "",
      system_store: {},
      shipping_type: 0,
      contacts: "",
      contactsTel: "",
      store_self_mention: 0,
      userInfo: {},
      storeList: {},
      istype: "",
      url: "",
      mjf_num: "",
      order_id: "",
      istype_hx: false
    };
  },
  watch: {
    // url() {
    //   if (this.url) {
    //     cookie.remove("Purl");
    //     this.$router.replace({
    //       path: this.url
    //     });
    //   }
    // },
    useIntegral() {
      this.computedPrice(1);
    },
    mjf_ms() {
      this.computedPrice(3);
    },
    useIntegralFg() {
      this.computedPrice(2);
    },
    $route(n) {
      if (n.name === NAME) {
        this.getUserInfo();
        this.getCartInfo();
      }
    },
    shipping_type() {
      this.computedPrice();
    }
  },
  mounted: function() {
    let that = this;
    that.getUserInfo();
    that.getCartInfo();
    that.getList();
    document.addEventListener("visibilitychange", this.handleVisiable);
    if (that.$route.query.pinkid !== undefined)
      that.pinkId = that.$route.query.pinkid;
    if (that.$route.params.id !== undefined)
      that.cartid = that.$route.params.id;
  },
  methods: {
    handleVisiable(e) {
      switch (e.target.visibilityState) {
        case "prerender":
          console.log("网页预渲染，内容不可见");
          break;
        case "hidden":
          console.log("内容不可见，处理后台、最小化、锁屏状态");
          break;
        case "visible":
          console.log("处于正常打开");
          if (this.url) {
            cookie.remove("Purl");
            if (this.istype == 11) {
              this.$router.replace({
                path: "/user/apply2?order_id=" + this.order_id + "&type=1"
              });
            } else {
              this.$router.replace({
                path: this.url
              });
            }
            this.url = "";
          }
          break;
      }
    },

    // 获取门店列表数据
    getList: function() {
      let data = {
        latitude: cookie.get(LATITUDE) || "", //纬度
        longitude: cookie.get(LONGITUDE) || "", //经度
        page: 1,
        limit: 10
      };
      storeListApi(data)
        .then(res => {
          this.storeList = res.data.list[0];
        })
        .catch(err => {
          this.$dialog.error(err.msg);
        });
    },
    // 跳转到门店列表
    showStoreList() {
      this.$store.commit("GET_TO", "orders");
      this.$router.push("/shop/storeList/orders");
    },
    getUserInfo() {
      getUser()
        .then(res => {
          this.userInfo = res.data;
        })
        .catch(() => {});
    },
    addressType: function(index) {
      // if (index && !this.system_store.id)
      //   return this.$dialog.error("暂无门店信息，您无法选择到店自提！");
      if (
        (this.istype == 9 || this.istype == 11 || this.istype_hx) &&
        index == 0
      ) {
        this.$dialog.error("该商品不支持快递配送");
      } else {
        this.shipping_type = index;
      }
    },
    computedPrice(news) {
      let shipping_type = this.shipping_type;
      if (this.useIntegralFg && this.useIntegral && news == 1) {
        this.useIntegralFg = false;
      }
      if (this.useIntegralFg && this.useIntegral && news == 2) {
        this.useIntegral = false;
      }
      postOrderComputed(this.orderGroupInfo.orderKey, {
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        useIntegralFg: this.useIntegralFg ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        shipping_type: parseInt(shipping_type) + 1,
        payType: this.active,
        mjf_ms: this.mjf_ms ? 1 : 0
      })
        .then(res => {
          const data = res.data;
          if (data.status === "EXTEND_ORDER") {
            this.$router.replace({
              path: "/order/detail/" + data.result.orderId
            });
          } else {
            this.orderPrice = data.result;
          }
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    getCartInfo() {
      const cartIds = this.$route.params.id;
      if (!cartIds) {
        this.$dialog.error("参数有误");
        return this.$router.go(-1);
      }
      postOrderConfirm(cartIds)
        .then(res => {
          this.offlinePayStatus = res.data.offline_pay_status;
          this.orderGroupInfo = res.data;
          this.deduction = res.data.deduction;
          this.usableCoupon = res.data.usableCoupon || {};
          this.addressInfo = res.data.addressInfo || {};
          this.system_store = res.data.system_store || {};
          this.store_self_mention = res.data.store_self_mention;
          this.istype = res.data.cartInfo[0].productInfo.istype;
          this.is_hx = res.data.cartInfo[0].productInfo.is_hx;
          if (this.istype == 5) {
            this.istype_hx = this.is_hx == 1 ? true : false;
          }
          if (this.istype == 9 || this.istype == 11 || this.istype_hx) {
            this.shipping_type = 1;
          }
          this.computedPrice();
          if (res.data.md_mark) {
            // confirm(res.data.md_mark);
            this.$dialog.confirm({
              mes: res.data.md_mark,
              title: "温馨提示",
              opts: [
                {
                  txt: "继续支付",
                  color: false,
                  callback: () => {}
                },
                {
                  txt: "返回首页",
                  color: false,
                  callback: () => {
                    return this.$router.push({ path: "/" });
                  }
                }
              ]
            });
          }
        })
        .catch(res => {
          this.$dialog.error(res.msg);
          setTimeout(() => {
            this.$router.go(-1);
          }, 1500);
        });
    },
    addressTap: function() {
      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },
    addressRedirect() {
      this.addressLoaded = false;
      this.showAddress = false;
    },
    couponTap: function() {
      this.showCoupon = true;
    },
    changeCoupon: function(coupon) {
      if (!coupon) {
        this.usableCoupon = { coupon_title: "不使用优惠券", id: 0 };
      } else {
        this.usableCoupon = coupon;
      }
      this.computedPrice();
    },
    payItem: function(index) {
      this.active = index;
      this.computedPrice();
    },
    changeAddress(addressInfo) {
      this.addressInfo = addressInfo;
      this.computedPrice();
    },
    createOrder() {
      let that = this;
      let shipping_type = this.shipping_type;
      if (!this.active) return this.$dialog.toast({ mes: "请选择支付方式" });
      if (
        !this.addressInfo.id &&
        !this.shipping_type &&
        this.orderGroupInfo.cartInfo[0].productInfo.istype !== 7
      )
        return this.$dialog.toast({ mes: "请选择收货地址" });
      if (
        this.shipping_type &&
        this.orderGroupInfo.cartInfo[0].productInfo.istype !== 11
      ) {
        if (
          (this.contacts === "" || this.contactsTel === "") &&
          this.shipping_type
        )
          return this.$dialog.toast({ mes: "请填写联系人或联系人电话" });
        if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.contactsTel)) {
          return this.$dialog.toast({ mes: "请填写正确的手机号" });
        }
        if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.contacts)) {
          return this.$dialog.toast({ mes: "请填写您的真实姓名" });
        }
      }
      let show = true;
      console.log(this.storeItem);
      if (this.storeItem) {
        if (this.storeItem.id) {
          show = false;
        }
      } else {
        show = true;
      }
      if (
        this.shipping_type &&
        this.orderGroupInfo.cartInfo[0].productInfo.istype == 9 &&
        show
      ) {
        return this.$dialog.error("暂无门店信息，您无法选择到店自提！");
      }
      if (this.orderGroupInfo.cartInfo[0].productInfo.istype == 9) {
        this.$dialog.confirm({
          mes: "确认是该门店吗?",
          opts: () => {
            that.$dialog.loading.open("生成订单中");
            createOrder(that.orderGroupInfo.orderKey, {
              real_name: that.contacts,
              phone: that.contactsTel,
              addressId: that.addressInfo.id,
              useIntegralFg: that.useIntegralFg ? 1 : 0,
              useIntegral: that.useIntegral ? 1 : 0,
              couponId: that.usableCoupon.id || 0,
              payType: that.active,
              pinkId: that.pinkId,
              seckill_id: that.orderGroupInfo.seckill_id,
              combinationId: that.orderGroupInfo.combination_id,
              bargainId: that.orderGroupInfo.bargain_id,
              from: that.from,
              mark: that.mark || "",
              shipping_type: parseInt(shipping_type) + 1,
              store_id: that.storeItem ? that.storeItem.id : 0,
              mjf_ms: that.mjf_ms ? 1 : 0
            })
              .then(res => {
                that.$dialog.loading.close();
                const data = res.data;
                let url;
                if (data.result.orderId) {
                  that.order_id = data.result.orderId;
                } else {
                  that.order_id = data.result.order_id;
                }

                if (data.result.orderId) {
                  url = "/order/status/" + data.result.orderId;
                } else {
                  url = "/order/status/" + data.result.order_id;
                }
                switch (data.status) {
                  case "ORDER_EXIST":
                  case "EXTEND_ORDER":
                  case "PAY_DEFICIENCY":
                    that.$dialog.toast({ mes: res.msg });
                    that.$router.replace({
                      path: url + "/0?msg=" + res.msg
                    });
                    break;
                  case "ALIPAY":
                    cookie.set("Purl", url + "/3");
                    that.url = url + "/3";
                    setTimeout(() => {
                      window.location.href = data.result.config;
                    }, 100);
                    break;
                  case "PAY_ERROR":
                    that.$dialog.toast({ mes: res.msg });
                    that.$router.replace({
                      path: url + "/0?msg=" + res.msg
                    });
                    break;
                  case "SUCCESS":
                    that.$dialog.success(res.msg);
                    if (that.istype == 11) {
                      that.$router.replace({
                        path:
                          "/user/apply2?order_id=" + that.order_id + "&type=1"
                      });
                    } else {
                      that.$router.replace({
                        path: url + "/1"
                      });
                    }
                    break;
                  case "WECHAT_GZH_PAY":
                    let jsPay = res.data.result.jsConfig;
                    WeixinJSBridge.invoke(
                      "getBrandWCPayRequest",
                      {
                        appId: jsPay.payAppId, //公众号名称，由商户传入
                        timeStamp: jsPay.payTimeStamp, //时间戳
                        nonceStr: jsPay.paynonceStr, //随机串
                        package: jsPay.payPackage,
                        signType: jsPay.paySignType, //微信签名方式：
                        paySign: jsPay.paySign //微信签名
                      },
                      function(ress) {
                        if (ress.err_msg == "get_brand_wcpay_request:ok") {
                          if (this.istype == 11) {
                            this.$router.replace({
                              path:
                                "/user/apply2?order_id=" +
                                this.order_id +
                                "&type=1"
                            });
                          } else {
                            this.$router.replace({
                              path: url + "/1"
                            });
                          }
                        } else if (
                          ress.err_msg == "get_brand_wcpay_request:cancel"
                        ) {
                          this.$dialog.error("取消支付");
                          if (this.istype == 11) {
                            this.$router.replace({
                              path:
                                "/user/apply2?order_id=" +
                                this.order_id +
                                "&type=1"
                            });
                          } else {
                            this.$router.replace({
                              path: url + "/1"
                            });
                          }
                        } else {
                          this.$dialog.error("支付失败");
                          if (this.istype == 11) {
                            this.$router.replace({
                              path:
                                "/user/apply2?order_id=" +
                                this.order_id +
                                "&type=1"
                            });
                          } else {
                            this.$router.replace({
                              path: url + "/1"
                            });
                          }
                        }
                      }
                    );
                    break;
                  case "LSJF":
                    that.$dialog.success(res.msg);
                    if (that.istype == 11) {
                      that.$router.replace({
                        path:
                          "/user/apply2?order_id=" + that.order_id + "&type=1"
                      });
                    } else {
                      that.$router.replace({
                        path: url + "/5"
                      });
                    }
                    break;
                  case "WECHAT_H5_PAY":
                    cookie.set("Purl", url + "/2");
                    that.url = url + "/2";
                    setTimeout(() => {
                      window.location.href = data.result.jsConfig;
                    }, 100);
                    break;
                  case "WECHAT_PAY":
                    pay(data.result.jsConfig).finally(() => {
                      that.$router.replace({
                        path: url + "/4"
                      });
                    });
                }
              })
              .catch(err => {
                if (
                  err.msg.indexOf("邈积分不足") > -1 ||
                  err.msg.indexOf("签到积分不足") > -1
                ) {
                  that.$dialog.error(err.msg);
                } else {
                  that.$dialog.error(err.msg || "创建订单失败");
                  that.$router.go(-1);
                }
                that.$dialog.loading.close();
              });
          }
        });
      } else {
        this.$dialog.loading.open("生成订单中");
        createOrder(this.orderGroupInfo.orderKey, {
          real_name: this.contacts,
          phone: this.contactsTel,
          addressId: this.addressInfo.id,
          useIntegralFg: this.useIntegralFg ? 1 : 0,
          useIntegral: this.useIntegral ? 1 : 0,
          couponId: this.usableCoupon.id || 0,
          payType: this.active,
          pinkId: this.pinkId,
          seckill_id: this.orderGroupInfo.seckill_id,
          combinationId: this.orderGroupInfo.combination_id,
          bargainId: this.orderGroupInfo.bargain_id,
          from: this.from,
          mark: this.mark || "",
          shipping_type: parseInt(shipping_type) + 1,
          store_id: this.storeItem ? this.storeItem.id : 0,
          mjf_ms: this.mjf_ms ? 1 : 0
        })
          .then(res => {
            this.$dialog.loading.close();
            const data = res.data;
            let url;
            if (data.result.orderId) {
              this.order_id = data.result.orderId;
            } else {
              this.order_id = data.result.order_id;
            }

            if (data.result.orderId) {
              url = "/order/status/" + data.result.orderId;
            } else {
              url = "/order/status/" + data.result.order_id;
            }
            switch (data.status) {
              case "ORDER_EXIST":
              case "EXTEND_ORDER":
              case "PAY_DEFICIENCY":
                this.$dialog.toast({ mes: res.msg });
                this.$router.replace({
                  path: url + "/0?msg=" + res.msg
                });
                break;
              case "ALIPAY":
                // this.$router.replace({
                //   path: url + "/3"
                // });
                cookie.set("Purl", url + "/3");
                this.url = url + "/3";
                setTimeout(() => {
                  window.location.href = data.result.config;
                }, 100);
                // var div = document.createElement("DIV");
                // div.innerHTML = res.data.result.config;
                // document.body.appendChild(div);
                // document.forms[0].submit();
                break;
              case "PAY_ERROR":
                this.$dialog.toast({ mes: res.msg });
                this.$router.replace({
                  path: url + "/0?msg=" + res.msg
                });
                break;
              case "SUCCESS":
                this.$dialog.success(res.msg);
                if (this.istype == 11) {
                  this.$router.replace({
                    path: "/user/apply2?order_id=" + this.order_id + "&type=1"
                  });
                } else {
                  this.$router.replace({
                    path: url + "/1"
                  });
                }
                break;
              case "LSJF":
                this.$dialog.success(res.msg);
                if (this.istype == 11) {
                  this.$router.replace({
                    path: "/user/apply2?order_id=" + this.order_id + "&type=1"
                  });
                } else {
                  this.$router.replace({
                    path: url + "/5"
                  });
                }
                break;
              case "WECHAT_H5_PAY":
                // this.$router.replace({
                //   path: url + "/2"
                // });
                cookie.set("Purl", url + "/2");
                this.url = url + "/2";
                setTimeout(() => {
                  window.location.href = data.result.jsConfig;
                }, 100);
                break;
              case "WECHAT_GZH_PAY":
                let jsPay = res.data.result.jsConfig;
                WeixinJSBridge.invoke(
                  "getBrandWCPayRequest",
                  {
                    appId: jsPay.payAppId, //公众号名称，由商户传入
                    timeStamp: jsPay.payTimeStamp, //时间戳
                    nonceStr: jsPay.paynonceStr, //随机串
                    package: jsPay.payPackage,
                    signType: jsPay.paySignType, //微信签名方式：
                    paySign: jsPay.paySign //微信签名
                  },
                  function(ress) {
                    if (ress.err_msg == "get_brand_wcpay_request:ok") {
                      if (this.istype == 11) {
                        this.$router.replace({
                          path:
                            "/user/apply2?order_id=" + this.order_id + "&type=1"
                        });
                      } else {
                        this.$router.replace({
                          path: url + "/1"
                        });
                      }
                    } else if (
                      ress.err_msg == "get_brand_wcpay_request:cancel"
                    ) {
                      this.$dialog.error("取消支付");
                      if (this.istype == 11) {
                        this.$router.replace({
                          path:
                            "/user/apply2?order_id=" + this.order_id + "&type=1"
                        });
                      } else {
                        this.$router.replace({
                          path: url + "/1"
                        });
                      }
                    } else {
                      this.$dialog.error("支付失败");
                      if (this.istype == 11) {
                        this.$router.replace({
                          path:
                            "/user/apply2?order_id=" + this.order_id + "&type=1"
                        });
                      } else {
                        this.$router.replace({
                          path: url + "/1"
                        });
                      }
                    }
                  }
                );
                break;
              case "WECHAT_PAY":
                pay(data.result.jsConfig).finally(() => {
                  this.$router.replace({
                    path: url + "/4"
                  });
                });
            }
          })
          .catch(err => {
            if (
              err.msg.indexOf("邈积分不足") > -1 ||
              err.msg.indexOf("签到积分不足") > -1
            ) {
              this.$dialog.error(err.msg);
            } else {
              this.$dialog.error(err.msg || "创建订单失败");
              this.$router.go(-1);
            }
            this.$dialog.loading.close();
          });
      }
    }
  }
};
</script>
